var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0769 20.6205C25.0769 21.4862 24.2846 22.581 22.2748 23.5179C20.3466 24.4169 17.6124 24.9998 14.5385 24.9998C11.4645 24.9998 8.73034 24.4169 6.80208 23.5179C4.79229 22.581 4 21.4862 4 20.6205C4 19.7549 4.79229 18.6601 6.80208 17.7231C8.73034 16.8241 11.4645 16.2412 14.5385 16.2412C17.6124 16.2412 20.3466 16.8241 22.2748 17.7231C24.2846 18.6601 25.0769 19.7549 25.0769 20.6205Z",
    stroke: "#86868D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2729 5.77778C19.2729 8.4715 17.225 10.5556 14.8183 10.5556C12.4116 10.5556 10.3638 8.4715 10.3638 5.77778C10.3638 3.08406 12.4116 1 14.8183 1C17.225 1 19.2729 3.08406 19.2729 5.77778Z",
    stroke: "#86868D",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 29.9997,
    height: 26,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.29ed46a28d230d3747008c2ba4af2f77.svg";
export { ForwardRef as ReactComponent };